
    <fieldmagic-dialog
      label="Import from template"
      icon="import"
      [instance]="this"
    >
      <ng-template
        fieldmagicDialogButtonsTmp
      >
        <fieldmagic-primary-button
          icon="import"
          label="Import"
          (click)="onImport()"
          [isInProgress]="importing$ | async"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div
          *ngIf="(initializing$ | async) || (importing$ | async)"
          class="d-flex d-flex-gap flex-column align-items-center justify-content-center w-100"
        >
          <fieldmagic-icon [spin]="true"></fieldmagic-icon>
          <fieldmagic-text [content]="progress$ | async | translate"></fieldmagic-text>
        </div>

        <div
          *ngIf="(! (initializing$ | async) && ! (importing$ | async))"
          class="d-flex d-flex-gap flex-column w-100"
        >
          <fieldmagic-dropdown-input
            [(ngModel)]="template"
            label="Please select a standard template to use"
            placeholder="Please select a standard template to use"
            [options]="templates$ | async"
            [withRequiredMarker]="true"
            (ngModelChange)="onTemplateChange()"
          >
          </fieldmagic-dropdown-input>

          <ng-container *ngIf="template | filled">
            <fieldmagic-dropdown-input
              label="Asset Type"
              [(ngModel)]="assetType"
              [options]="assetTypes$ | async"
              [withRequiredMarker]="true"
              [errors]="errors | data_get: 'asset_type_id'"
            >
            </fieldmagic-dropdown-input>
          </ng-container>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  